import { createSlice } from '@reduxjs/toolkit';
import { IScanGroup } from 'pages/Sspm/components/ExternalIntegrations/ScanGroupsSelector';
import { fetchScanGroupsThunk, updateScanGroup } from './allInOneScanGroupActions';

type ScanGroupsState = {
  filteredScanOptions: IScanGroup[];
  searchScanText: string;
  openScanList: boolean;
  visibleScanGroups: boolean;
  connectedGroups: number[];
  scanOptions: IScanGroup[];
  selectedGroup: IScanGroup | undefined;
  isLoading: boolean;
  allScanOptions: (IScanGroup & { disabled: boolean })[];
};

const initialState: ScanGroupsState = {
  filteredScanOptions: [],
  searchScanText: '',
  openScanList: false,
  visibleScanGroups: false,
  connectedGroups: [],
  scanOptions: [],
  selectedGroup: undefined,
  isLoading: true,
  allScanOptions: []
};

const allInOneScanGroupsSlice = createSlice({
  name: 'allInOneScanGroups',
  initialState,
  reducers: {
    setFilteredScanOptions(state, action) {
      state.filteredScanOptions = action.payload;
    },
    setSearchScanText(state, action) {
      state.searchScanText = action.payload;
    },
    setOpenScanList(state, action) {
      state.openScanList = action.payload;
    },
    setVisibleScanGroups(state, action) {
      state.visibleScanGroups = action.payload;
    },
    setConnectedGroups(state, action) {
      state.connectedGroups = action.payload;
    },
    setScanOptions(state, action) {
      state.scanOptions = action.payload;
      state.filteredScanOptions = action.payload;
    },
    setSelectedGroup(state, action) {
      state.selectedGroup = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchScanGroupsThunk.fulfilled, (state, action) => {
        state.scanOptions = action.payload.options;
        state.selectedGroup = action.payload.selectedGroup;
        state.visibleScanGroups = action.payload.visibleScanGroups;
        state.connectedGroups = action.payload.connectedGroups;
        const allScanOptions = state.scanOptions.map(option => {
          return {
            ...option,
            disabled: !state?.connectedGroups?.includes(option.GroupId)
          };
        });
        state.allScanOptions = allScanOptions;
        state.isLoading = false;
      })
      .addCase(fetchScanGroupsThunk.rejected, state => {
        state.isLoading = false;
      })
      .addCase(updateScanGroup.pending, state => {
        state.isLoading = true;
        state.searchScanText = '';
        state.openScanList = false;
        if (state.scanOptions.length) {
          state.filteredScanOptions = state.scanOptions;
        }
      })
      .addCase(updateScanGroup.fulfilled, (state, action) => {
        state.selectedGroup = action.payload;
        state.isLoading = false;
      })
      .addCase(updateScanGroup.rejected, state => {
        state.isLoading = false;
      });
  }
});

export const {
  setFilteredScanOptions,
  setSearchScanText,
  setOpenScanList,
  setVisibleScanGroups,
  setConnectedGroups,
  setScanOptions,
  setSelectedGroup
} = allInOneScanGroupsSlice.actions;

export default allInOneScanGroupsSlice.reducer;
